import { render, staticRenderFns } from "./WorkspaceMenu.vue?vue&type=template&id=76216a3e&scoped=true"
import script from "./WorkspaceMenu.vue?vue&type=script&lang=js"
export * from "./WorkspaceMenu.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceMenu.vue?vue&type=style&index=0&id=76216a3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76216a3e",
  null
  
)

export default component.exports